<template>
	<div class="pages">
		<div class="goback" @click="goback"></div>
		<div class="userBack" @click="$router.push({ name: 'my' })"></div>
		<div class="titleBG">
			<!-- <img src="@/static/images/my/officeImg.png" alt="" /> -->
			<swiper ref="myHomeSwiper" class="home-swiper" :options="myHomeSwiperOptions">
				<swiper-slide v-for="(item, index) in detail.pics" :key="index" class="home-swiper-slide">
					<img :src="item" alt="" />
				</swiper-slide>
			</swiper>
		</div>

		<div class="details">
			<div class="details-info">
				<div v-if="detail.price * 1 == 0" class="money">免费</div>
				<div v-else class="money">¥&nbsp;{{detail.vip_apply_price}}~{{detail.price}}</div>
				<!-- <div v-if="detail.vip_apply_price * 1 == 0 && detail.price * 1 > 0" class="money">¥&nbsp;{{detail.price}}</div> -->
				<div class="title no-wrap-2">{{detail.title}}</div>
				<div class="time flex flex-align-center">
					<img src="@/static/images/index/time.png" alt="" />
					<div>{{moment(detail.start_time * 1000).format('yyyy-MM-DD HH:mm')}} ~ {{moment(detail.end_time * 1000).format('yyyy-MM-DD HH:mm')}}</div>
				</div>
				<div class="location flex flex-align-center">
					<img src="@/static/images/index/address.png" alt="" />
					<div class="flex-1">{{detail.address}}</div>
					<img src="@/static/images/icon-arrowRight.png" class="arrow" />
				</div>
				<div class="tipsList flex flex-align-center">
					<div v-for="(item, index) in detail.content" :key="item.title" @click="showDes(index)" class="tips flex flex-align-center">
						<img :src="item.icon" alt="" />
						<div>{{item.title}}</div>
					</div>
					<!-- <div class="tips flex flex-align-center">
						<img src="@/static/images/index/tui.png" alt="" />
						<div>不支持退款</div>
					</div>
					<div class="tips flex flex-align-center">
						<img src="@/static/images/index/money.png" alt="" />
						<div>支持现场报名支付</div>
					</div> -->
				</div>
			</div>

			<!-- @click="$router.push({'name': 'activityList_people'})" -->
			<div @click="show = true" v-if="detail.is_enroll == 1" class="details-people flex flex-align-center" >
				<div>已报名：</div>
				<div class="people flex-1">{{detail.join_count}}<template v-if="detail.quota != -1">/{{detail.quota}}</template>人</div>
				<div class="avatarList flex">
					<img v-for="item in detail.join" :key="item.id" :src="item.avatar" class="avatar" />
				</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow" />
			</div>

			<div class="details-introduce">
				<div class="title">介绍</div>
				<div class="content dialog-h5" v-html="detail.brief"></div>
			</div>
		</div>

		<div class="detailsBottom flex flex-align-center flex-jus-between">
			<div class="left flex flex-align-center">
				<div class="flex flex-column" @click="advShow = true">
					<img src="@/static/images/index/zixun.png" class="icon" />
					<span style="margin-top: 4px;">咨询</span>
				</div>
				<div class="fenxiang flex flex-column" @click="shareShow = true">
					<img src="@/static/images/index/fenxiang.png" class="icon" />
					<span style="margin-top: 4px;">分享</span>
				</div>
			</div>
			<template v-if="detail.user_join.is_pay == 1" >
				<div v-if="new Date().getTime() < detail.end_time * 1000" class="right right-enough">
					已报名
				</div>
				<div v-else class="right right-dis flex flex-align-center flex-jus-center">
					活动已结束
				</div>
			</template>
			<template v-else>
				<div v-if="new Date().getTime() < detail.enroll_end_time * 1000 " class="right flex flex-column" @click="dialogConfirm">
					<div class="text1">我要报名</div>
					<div class="text2">{{moment(detail.enroll_end_time * 1000).format('MM月DD日 HH:mm')}}报名截止</div>
				</div>
				<div v-if="new Date().getTime() > detail.enroll_end_time * 1000" class="right right-dis flex flex-column">
					<div class="text1">已结束</div>
					<div class="text2">{{moment(detail.enroll_end_time * 1000).format('MM月DD日 HH:mm')}}报名截止</div>
				</div>
				<div v-if="detail.quota!=-1 && detail.quota <= detail.join_count && new Date().getTime() < detail.enroll_end_time * 1000" class="right right-enough">
					名额已满
				</div>
			</template>
		</div>

		<!-- 分享弹窗 -->
		<van-overlay :show="shareShow" @click="shareShow = false">
			<div class="sharePop">
				<div class="sharePop-arrow"><img src="@/static/images/index/arrow-share.png" alt="" /></div>

				<div class="sharePop-text">
					点击右上角
					<br />
					选择发送对象
				</div>
			</div>
		</van-overlay>
		<!-- 咨询方式 弹窗 -->
		<van-overlay :show="advShow" @click="advShow = false">
			<div class="advPop" @click.stop>
				<div class="title">咨询方式</div>

				<div class="advPop-box flex flex-align-center">
					<img src="@/static/images/my/phone2.png" class="icon" />
					<div class="flex-1">{{detail.phone}}</div>
					<div class="advButton flex flex-align-center flex-jus-center">
						<img src="@/static/images/my/phone.png" alt="" />
						<div>拨打</div>
					</div>

					<a :href="'tel:' + detail.phone" class="telPhone"></a>
				</div>

				<div class="advPop-box flex flex-align-center" style="border-bottom: none;">
					<img src="@/static/images/my/weixin.png" class="icon" />
					<div class="flex-1">{{detail.wechat}}</div>
					<div @click="copy(detail.wechat)" class="advButton flex flex-align-center flex-jus-center">
						<img src="@/static/images/my/fuzhi.png" alt="" />
						<div>复制</div>
					</div>
				</div>

				<div class="cancel" @click="advShow = false"></div>
			</div>
		</van-overlay>
		<!-- 说明 弹窗 -->
		<van-overlay :show="desShow" @click="desShow = false" :lock-scroll="false">
			<div class="desPop">
				<div class="desPop-title">{{ desTitle }}</div>
				<div class="desPop-content" v-html="desContent"></div>
			</div>
		</van-overlay>
		<van-popup v-model="show" position="bottom" round :style="{ height: '500px' }">
			<div class="join-top">
				已报名 {{detail.join_count}}<template v-if="detail.quota != -1">/{{detail.quota}}</template>人
			</div>
			<div class="flex flex-wrap">
				<div @click="$router.push({name: 'my_homePage', query: {id: item.user_id}})" v-for="item in joinData" :key="item.user_id" class="join-item">
					<img class="join-avatar" :src="item.avatar" alt="">
					<div class="join-name">{{item.username}}</div>
				</div>
			</div>
		</van-popup>
		<van-popup v-model="showPicker" round position="bottom">
			<van-picker
				title="选择地图"
				show-toolbar
				:columns="maps"
				@confirm="mapConfirm"
			/>
		</van-popup>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	beforeRouteEnter(to, from, next) {
		next(vm => {
			// 通过 `vm` 访问组件实例,将值传入fromPath
			vm.fromPath = from.path;
		});
	},
	data() {
		return {
			myHomeSwiperOptions: {
				autoplay: false
			},
			activity_id: '',
			detail: {
				user_join: {}
			},
			fromPath: '',
			advShow: false,
			shareShow: false,
			desShow: false,
			desTitle: '',
			desContent: '',

			joinData: [],
			show: false,

			showPicker: false,
			maps: [
				'腾讯地图',
				'高德地图',
				'百度地图'
			]
		};
	},
	created() {
	},
	mounted() {
		this.activity_id = this.$route.query.id
		this.getData()
		this.$nextTick(() => {
			// 验证是否获取到了上页的url
			/* eslint-disable no-console */
			console.log(this.fromPath, 'fromPath');
		});
	},
	methods: {
		getData() {
			this.$get('api/activity/getActivityDetails', {
				activity_id: this.activity_id
			}).then(res => {
				this.detail = res.data
				if (this.detail.is_enroll == 1) {
					this.getJoinData()
				}
				this.$wx.updateAppMessageShareData({
					title: this.detail.share_title, // 分享标题
					desc: this.detail.share_desc || '', // 分享描述
					link: location.href,
					imgUrl: this.detail.share_pic, // 分享图标
				});
				this.$wx.updateTimelineShareData({
					title: this.detail.share_title, // 分享标题
					link: location.href,
					imgUrl: this.detail.share_pic, // 分享图标
				});
			})
		},
		getJoinData() {
			this.$get('api/activity/getActivityJoinList', {
				activity_id: this.activity_id,
				pageSize: this.detail.quota == -1 ? 10000 : this.quota,
				page: 1
			}).then(res => {
				this.joinData = res.data
			})
		},
		showDes(index) {
			let value = this.detail.content[index]
			this.desTitle = value.title
			this.desContent = value.content
			this.desShow = true
		},
		apply() {
			this.$dialog
				.confirm({
					title: '报名成功',
					message: '恭喜你报名成功！',
					confirmButtonText: '查看报名',
					confirmButtonColor: '#DE113C',
					cancelButtonText: '继续浏览',
					cancelButtonColor: '#606060'
				})
				.then(() => {
					this.$router.push({name: 'my_activity'})
				})
				.catch(() => {
					// on cancel
					this.getData()
				});
		},
		// 报名确认
		dialogConfirm() {
			let Mobile = localStorage.getItem('mobile')
			if (!Mobile) {
				this.$router.push('/login/loginPhone')
        return
			}
			this.$dialog
				.confirm({
					title: '报名确认',
					message: '您确定要报名该活动嘛？',
					confirmButtonText: '立即报名',
					confirmButtonColor: '#DE113C',
					cancelButtonText: '再想想',
					cancelButtonColor: '#606060'
				})
				.then(() => {
					this.makeOrder()
				})
				.catch(() => {
					// on cancel
				});
		},
		// 下单
		makeOrder() {
			this.$post('api/pay/unifyOrder', {
				type: 1,
				relation_id: this.activity_id
			}).then(res => {
				this.makeApply(res.data.order_no)
			})
		},
		makeApply(order_no) {
			this.$post('api/pay/unifyPay', {
				order_no,
				pay_type: 1,
				is_jssdk: 1
			}).then(res => {
				// && ((Number(this.detail.price) == 0) || (Number(this.detail.vip_apply_price) == 0))
				if (res.code == 7002) {
					this.apply()
				} else {
					this.$wx.chooseWXPay({
						timestamp: res.data.timeStamp,
						nonceStr: res.data.nonceStr,
						package: res.data.package,
						signType: 'MD5',
						paySign: res.data.paySign,
						success: (ress) => {
							if (ress.errMsg === 'chooseWXPay:ok') {
								this.apply()
							}
						}
					})
				}
			})
		},

		// 返回
		goback() {
			// console.log(this.$router.go(-1));
			if (this.fromPath == '/' || this.fromPath == '/my') {
				this.$router.push({ name: 'my' });
				return;
			}
			this.$router.go(-1);
		},
		// 复制剪贴板
		copy(str) {
			var save = function(e) {
				e.clipboardData.setData('text/plain', str);
				e.preventDefault();
			};
			document.addEventListener('copy', save);
			document.execCommand('copy');
			document.removeEventListener('copy', save);
			this.$toast('复制成功');
			console.log('复制成功');
		},
		mapConfirm(e) {
			let url = '';
			let lat = this.detail.lat
			let lng = this.detail.lon
			let address = this.detail.address
      switch(e) {
				case '腾讯地图':
						url = 'https://apis.map.qq.com/uri/v1/marker?marker=coord:' + lat + ',' +  lng +';addr:'+ address +';title:地址&referer=keyfree';
						break;
				case '高德地图':
						url = 'https://uri.amap.com/marker?position='+ lng + ',' + lat +'&name='+ address +'&callnative=1';
						break;
				case '百度地图':
						url = 'http://api.map.baidu.com/marker?location=' + lat + ',' +  lng +'&title=地址&content='+ address +'&output=html&src=webapp.reformer.appname&coord_type=gcj02';
						break;
				default:
						break;
      }
			location.href=url
      // return url;
		}
	}
};
</script>

<style lang="stylus">
.van-dialog__header
	font-weight bold
</style>
<style scoped>
	.dialog-h5 >>> img {
		max-width: 100%;
		height: auto;
	}
	.desPop-content >>> img {
		max-width: 100%;
		height: auto;
	}
</style>

<style scoped lang="stylus">

.desPop
	margin 20vh auto 0 auto
	padding 28px 24px 72px 24px
	width: 640px;
	background: #FFFFFF;
	border-radius: 20px;
	.desPop-title
		width 100%
		text-align center
		font-size: 36px;
		font-weight: 800;
		color: #333333;
		margin-bottom 40px
	.desPop-content
		max-height 50vh
		overflow-y auto
		font-size 30px
.advPop
	width 640px
	margin 30vh auto 0 auto
	background-color #FFFFFF
	border-radius 20px
	padding 28px 0 0 0
	position relative
	.cancel
		position absolute
		width 48px
		height 48px
		bottom -88px
		left calc(50% - 24px)
		background-image url('~@/static/images/my/cancel.png')
		background-size 100% 100%
		background-position center
	.title
		width 100%
		text-align center
		font-size 36px
		font-weight 800
		color #333333
	.advPop-box
		width 100%
		padding 40px 38px
		font-size 26px
		color #000000
		border-bottom 2px solid #F7F7F7
		position relative
		.telPhone
			position absolute
			width 100%
			height 100%
			background transparent
		.icon
			width 36px
			height 36px
			margin-right 10px
		.advButton
			width 164px
			height 60px
			font-size 24px
			color #FFFFFF
			background-image url('~@/static/images/index/btnBG.png')
			background-position center
			background-size 100% 100%
			img
				width 26px
				height 26px
				margin-right 12px
.sharePop-arrow
	position fixed
	right 40px
	top 20px
	width 46px
	height 54px
	img
		width 100%
		height 100%
.sharePop-text
	position fixed
	right 30px
	top 88px
	width 200px
	font-size 30px
	font-weight bold
	color #FFFFFF
	text-align center
.pages
	min-height 100vh
	background-color #F6F6F6
	overflow-y auto
	padding-bottom 120px
.titleBG
	width 100%
	height 400px
	z-index 0
	position relative
	img 
		width 750px
		height 400px
.goback
	position fixed
	left 30px
	top 24px
	width 52px
	height 52px
	background-image url('~@/static/images/icon-arrowLeft.png')
	background-size 100% 100%
	background-position center
	z-index 10
.userBack
	position fixed
	right 30px
	top 24px
	width 52px
	height 52px
	background-image url('~@/static/images/icon-my.png')
	background-size 100% 100%
	background-position center
	z-index 10
	
.details
	padding 0 30px
	.details-info
		margin-top -44px
		padding 24px
		background-color #FFFFFF
		position relative
		border-radius 20px
		.money
			font-size 36px
			font-weight bold
			color #DE113C
		.title
			padding-top 16px
			padding-bottom 26px
			font-size 30px
			font-weight bold
			color #000000
			border-bottom 2px solid #F7F7F7
		.time
			margin-top 24px
			font-size 26px
			color #000000
			img
				width 26px
				height 26px
				margin-right 12px
		.location
			margin-top 28px
			font-size 26px
			color #000000
			img
				width 22px
				height 26px
				margin-right 16px
			.arrow
				width 12px
				height 22px
		.tipsList
			margin-top 44px
			.tips
				margin-right 52px
				font-size 24px
				color #B1B1B1
				&:nth-child(3n)
					margin-right 0 !important
				img
					width 30px
					height 30px
					margin-right 10px
	.details-people
		padding 32px 24px
		background #FFFFFF
		border-radius 20px
		font-size 26px
		font-weight bold
		color #111111
		margin-top 28px
		.people
			font-size 26px
			font-weight 500
			color #DE113C
		.avatar
			width 54px
			height 54px
			border-radius 50%
			margin-right -25px
			&:last-child
				margin-right 0
		.arrow
			width 12px
			height 22px
			margin-left 16px
	.details-introduce
		margin-top 28px
		padding 24px
		background-color #FFFFFF
		.title
			width 100%
			background-image url('~@/static/images/my/apply-circle.png')
			background-position left top
			background-size 38px 46px
			background-repeat no-repeat
			padding-left 12px
			padding-top 6px
			font-size 32px
			font-weight bold
			color #000000
			margin-bottom 28px
		.content
			word-break break-all
			font-size 26px
			color #333
.detailsBottom
	position fixed
	bottom 0
	left 0
	width 100%
	height 100px
	background #FFFFFF
	box-shadow 0px 0px 6px rgba(34, 48, 94, 0.25)
	.icon
		width 44px
		height 44px
	.left
		font-size 24px
		color #333333
		margin-left 32px
		.fenxiang
			margin-left 84px
	.right
		width 406px
		height 100px
		background #DE113C
		color #FFFFFF
		font-size 24px
		text-align center
		.text1
			margin-top 10px
			font-size 28px
			font-weight bold
			color #FFFFFF
		.text2
			margin-top 4px
	.right-dis
		background #CCCCCC
		.text1, .text2
			color #707070
.right-enough
	text-align center
	font-size 28px
	font-weight bold
	line-height 100px
.join-top
	font-size 34px
	color #0a0a0a
	font-weight bold
	text-align center
	padding 40px 0
.join-item
	width 20%
	text-align center
	font-size 0
	margin-bottom 40px
.join-avatar
	width 84px
	height 84px
	margin-bottom 16px
	border-radius 50%
	overflow hidden
.join-name
	font-size 26px
	color #000
</style>
